import React from "react";
import { Collapse } from "antd";
import { CollapseComponentProps } from "interfaces/ClientInterface/ICollapse";
import "./Collapse.scss";
const { Panel } = Collapse;

const CollapseComponent = ({
  title,
  children,
  size,
  dataTestSelector,
  isAccordion,
  customPanel,
  onChange,
  defaultActiveKey = "1",
  className
}: CollapseComponentProps) => {
  return (
    <Collapse
      ghost
      bordered={false}
      size={size}
      data-test-selector={dataTestSelector}
      accordion={isAccordion}
      defaultActiveKey={[defaultActiveKey]}
      onChange={onChange}
      className={`mt-16 ${className}`}
    >
      {customPanel ? (
        children
      ) : (
        <Panel header={title} key="1" className="collapse-container">
          {children}
        </Panel>
      )}
    </Collapse>
  );
};
export default CollapseComponent;
